<template>
  <div class="btn-group" role="group" aria-label="Language switcher">
    <button
      type="button"
      class="btn btn-sm"
      :class="current === 'ar' ? 'btn-success' : 'btn-light'"
      @click="setLocale('ar')"
    >
      {{ $t("lang.arabic") }}
    </button>
    <button
      type="button"
      class="btn btn-sm"
      :class="current === 'en' ? 'btn-success' : 'btn-light'"
      @click="setLocale('en')"
    >
      {{ $t("lang.english") }}
    </button>
  </div>
</template>

<script>
import i18n, { switchLocale } from "@/plugins/i18n";

export default {
  name: "LanguageSwitcher",
  data() {
    return {
      current: i18n.global.locale.value,
    };
  },
  methods: {
    setLocale(locale) {
      if (this.current === locale) return;
      switchLocale(locale);
      this.current = i18n.global.locale.value;
    },
  },
};
</script>

<style scoped></style>
